import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { "aria-labelledby": "paginationHeading" }
const _hoisted_2 = {
  class: "sr-only",
  id: "paginationHeading",
  role: "status",
  "aria-live": "polite"
}
const _hoisted_3 = {
  key: 0,
  class: "ds-pagination"
}

import { computed, ComputedRef } from "vue";
import DsButton from "../button/ds-button.vue";
import PaginationItem from "../pagination-item/pagination-item.vue";
import type { Theme } from "../types/theme";


export default /*@__PURE__*/_defineComponent({
  __name: 'ds-pagination',
  props: {
    totalPages: {},
    currentPage: {},
    theme: { default: "light" },
    onClickHandler: {}
  },
  setup(__props: any) {

const props = __props;

const leftArrowDisabled = computed(() => props.currentPage == 1);
const rightArrowDisabled = computed(() => props.currentPage == props.totalPages);

const getArrayOfPages: ComputedRef<number[]> = computed(() => {
    if (props.totalPages < 7) {
        return Array.from({ length: props.totalPages }, (_, i) => i + 1);
    } else if (props.currentPage <= 3) {
        return [1, 2, 3, 4, 5];
    } else if (props.currentPage === 4 && props.totalPages == 7) {
        return [3, 4, 5, 6];
    } else if (props.currentPage === 4 && props.totalPages > 7) {
        return [3, 4, 5];
    } else if (props.currentPage >= props.totalPages - 3) {
        return [4, 3, 2, 1, 0].map((item) => props.totalPages - item);
    } else {
        return [-1, 0, 1].map((item) => props.currentPage + item);
    }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("nav", _hoisted_1, [
    _createElementVNode("span", _hoisted_2, " Výsledky stránkovače - stránka " + _toDisplayString(_ctx.currentPage) + " z " + _toDisplayString(_ctx.totalPages), 1),
    (_ctx.totalPages > 1)
      ? (_openBlock(), _createElementBlock("ul", _hoisted_3, [
          _createElementVNode("li", {
            class: _normalizeClass(["ds-pagination__arrow", { 'ds-pagination__arrow--disabled': leftArrowDisabled.value }])
          }, [
            _createVNode(DsButton, {
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onClickHandler(_ctx.currentPage - 1))),
              "aria-label": "Předešlá stránka",
              type: "interaction",
              theme: _ctx.theme,
              "is-disabled": leftArrowDisabled.value,
              "icon-left": "arrow-left"
            }, null, 8, ["theme", "is-disabled"])
          ], 2),
          (_ctx.currentPage === 1)
            ? (_openBlock(), _createBlock(PaginationItem, {
                key: 0,
                type: "activeItem",
                "page-number": 1
              }))
            : (_openBlock(), _createBlock(PaginationItem, {
                key: 1,
                type: "item",
                "page-number": 1,
                "on-click-handler": _ctx.onClickHandler
              }, null, 8, ["on-click-handler"])),
          (_ctx.currentPage > 3 && _ctx.totalPages > 6)
            ? (_openBlock(), _createBlock(PaginationItem, {
                key: 2,
                type: "dots"
              }))
            : _createCommentVNode("", true),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getArrayOfPages.value, (page, index) => {
            return (_openBlock(), _createElementBlock(_Fragment, { key: page }, [
              (!(page === 1 || page === _ctx.totalPages))
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    (page === _ctx.currentPage)
                      ? (_openBlock(), _createBlock(PaginationItem, {
                          key: 0,
                          type: "activeItem",
                          "page-number": page
                        }, null, 8, ["page-number"]))
                      : (_openBlock(), _createBlock(PaginationItem, {
                          key: 1,
                          type: "item",
                          "page-number": page,
                          "hide-on-xs": index === 0 || (_ctx.totalPages > 6 && index === 4),
                          "on-click-handler": _ctx.onClickHandler
                        }, null, 8, ["page-number", "hide-on-xs", "on-click-handler"]))
                  ], 64))
                : _createCommentVNode("", true)
            ], 64))
          }), 128)),
          (_ctx.currentPage < _ctx.totalPages - 3 && _ctx.totalPages > 6)
            ? (_openBlock(), _createBlock(PaginationItem, {
                key: 3,
                type: "dots"
              }))
            : _createCommentVNode("", true),
          (_ctx.currentPage === _ctx.totalPages)
            ? (_openBlock(), _createBlock(PaginationItem, {
                key: 4,
                type: "activeItem",
                "page-number": _ctx.totalPages
              }, null, 8, ["page-number"]))
            : (_openBlock(), _createBlock(PaginationItem, {
                key: 5,
                type: "item",
                "page-number": _ctx.totalPages,
                "on-click-handler": _ctx.onClickHandler
              }, null, 8, ["page-number", "on-click-handler"])),
          _createElementVNode("li", {
            class: _normalizeClass(["ds-pagination__arrow", { 'ds-pagination__arrow--disabled': rightArrowDisabled.value }])
          }, [
            _createVNode(DsButton, {
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onClickHandler(_ctx.currentPage + 1))),
              "aria-label": "Nasledující stránka",
              type: "interaction",
              theme: _ctx.theme,
              "is-disabled": rightArrowDisabled.value,
              "icon-right": "arrow-right"
            }, null, 8, ["theme", "is-disabled"])
          ], 2)
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})